// extracted by mini-css-extract-plugin
var _1 = "aXtf7";
export { _1 as "base" }
